const loginRequest = (url: string) => url.includes("login");

export const requestRequiresHeaderData = (url: string) => !loginRequest(url);

export const addRequestHeaderData = (header: any, command: string) => {
  return {
    ...header,
    apiVersion: "1.4",
    appType: "organisation",
    output: "json",
    command: command,
  };
};

export const addSidToRequestHeaderData = (data: any, appSessionKey: string, uuid: string) => {
  return {
    ...data,
    ver: "1.9",
    sid: uuid + "::organisation::" + appSessionKey,
  };
};

export const addSidToRequestURL = (url: string, appSessionKey: string, uuid: string) => {
  let newUrl = url || "";
  newUrl += newUrl.includes("?") ? "&" : "?";
  newUrl += "sid=" + uuid + "::organisation::" + appSessionKey;
  return newUrl;
};

export const logApiError = (service: string, call: string, payload: any, error: any) => {
  console.error(
    `${service}.service: ${call}((${payload ? JSON.stringify(payload) : ""})) returned ERROR: ${JSON.stringify(
      error,
      null,
      4
    )}`
  );
};
